import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { DocumentListPage } from './routes/DocumentListPage.tsx';
import { EditorPage } from './routes/EditorPage.tsx';
import { ErrorBoundary, ErrorFallback } from './errors/index.ts';
import { useAssetSweep, useDocumentStore } from './storage/index.ts';

export function App() {
  const location = useLocation();

  // Reclaim the bytes of images no document refers to any more. At start-up
  // only: mid-session it would quietly break the next undo.
  useAssetSweep(useDocumentStore());

  return (
    // The outermost boundary. Without it, anything thrown during render leaves
    // a blank page — no message, no way back, and no clue that the documents
    // are still safely in this browser.
    //
    // Keyed by pathname, and it offers the way home. While an error is held,
    // `Routes` is unmounted: Back and Forward change the URL and nothing on
    // screen responds, so without both of these a crash on `/d/:id` is a dead
    // end that only a reload escapes.
    <ErrorBoundary
      resetKey={location.pathname}
      fallback={(error, reset) => <ErrorFallback error={error} onRetry={reset} />}
    >
      <Routes>
        <Route path="/" element={<DocumentListPage />} />
        <Route path="/d/:id" element={<EditorPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
